import { title } from "assets/jss/material-kit-react.jsx";

const sharePollStyle = {
  section: {
    // padding: "70px 0",
    paddingTop: 50,
    // paddingBottom: 20,
    paddingLeft: 15,
    textAlign: "left"
    // margin-left: auto;
    // margin-right: auto;
  },
  title: {
    ...title,
    marginTop: 10,
    marginBottom: 10,
    letterSpacing: 1,
    paddingLeft: 7,
    fontSize: 24,
    // lineHeight: 28,
    fontWeight: 500,
    textTransform: "none",
    textAlign: "left",
    color: "#333",
  },
  socialIcons: {
    width: 65,
    padding: "15px 7px",
    maxWidth: "100%",
    display: "inline-block",
  },
  socialShareButton: {
    display: "inline-block",
    cursor: "pointer",
    "&:hover,&:focus": {
      opacity: 0.75,
    },
    // padding: "15px 7px",
    // maxWidth: "100%",
    // display: "inline-block",
  },
  disableLink: {
    pointerEvents: 'none',
  },
  socialIconContainer: {
    justifyContent: "center",
    paddingTop: 25,
    // textAlign: "center",
    // padding: "15px 7px",
    // maxWidth: "100%",
    // display: "inline-block",
  },
  description: {
    color: "#999"
  }
};

export default sharePollStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/pollTemplateSections/sharePollStyle.jsx